import { render, staticRenderFns } from "./Form4bis.vue?vue&type=template&id=0050b990&scoped=true"
import script from "./Form4bis.vue?vue&type=script&lang=js"
export * from "./Form4bis.vue?vue&type=script&lang=js"
import style0 from "./Form4bis.vue?vue&type=style&index=0&id=0050b990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0050b990",
  null
  
)

export default component.exports